export const LEVEL_OF_SERVICE_COLORS = [
  { value: 5, color: '#DB6464' },
  { value: 4, color: '#EDB290' },
  { value: 3, color: '#EDCF91' },
  { value: 2, color: '#D0D49A' },
  { value: 1, color: '#B5D9A1' },
];
